import { Reveal } from "./Reveal";

export const PageHeader = ({ kicker, title, description }) => (
  <header className="mx-auto w-full max-w-7xl px-6 pb-12 pt-28 md:pb-24 md:pt-44">
    <Reveal>
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-paper-500" data-testid="page-kicker">
        {kicker}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h1
        className="mt-5 max-w-4xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-paper-100 sm:text-5xl lg:text-6xl"
        data-testid="page-title"
      >
        {title}
      </h1>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-paper-400 md:text-lg" data-testid="page-description">
          {description}
        </p>
      </Reveal>
    )}
  </header>
);
